import { SvgIcon, SvgIconProps } from '@mui/material'

export function TreeListIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 10A.75.75 0 0 1 9 9.25h10a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v-4Zm1.5.75v2.5h8.5v-2.5h-8.5ZM8.25 3A.75.75 0 0 1 9 2.25h7a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75H9A.75.75 0 0 1 8.25 7V3Zm1.5.75v2.5h5.5v-2.5h-5.5ZM8.25 17a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v-4Zm1.5.75v2.5h11.5v-2.5H9.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6A.75.75 0 0 1 1.75 5ZM1.75 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75ZM1.75 19a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 1.25a.75.75 0 0 1 .75.75v20a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default TreeListIcon
